import type { IReport } from '../reports'

export const visitorsReports: IReport[] = [
  {
    ReportName: 'Auto Checked Out Users',
    ReportSubText: 'This report shows the number of users who have been automatically checked out',
    ReportGroup: 'Visitors',
    ReportExecuteName: 'visitors_autoCheckedOut',
    Filters: [
      {
        type: 'visitUserTypes',
        label: 'Visit User Types',
        fieldName: 'visitUserTypes',
        required: true,
      },
      {
        type: 'date',
        label: 'From Date',
        fieldName: 'startDate',
        required: true,
      },
      {
        type: 'date',
        label: 'To Date',
        fieldName: 'endDate',
        required: true,
      },
    ],
    Columns: [
      { title: 'Visitor', field: 'VisitorsName', width: 150, editor: 'input', headerFilter: true },
      { title: 'Company', field: 'CompanyName', width: 150, editor: 'input', headerFilter: true },
      { title: 'Auto Checkout Time', field: 'AutoCheckoutTime', width: 150, editor: 'input', headerFilter: true },
      { title: 'Location', field: 'Location', width: 150, editor: 'input', headerFilter: true },
      { title: 'Expected Time', field: 'ExpectedTime', width: 150, editor: 'input', headerFilter: true },
      { title: 'Visitor Type', field: 'VisitorType', width: 150, editor: 'input', headerFilter: true },
    ],
  },
  {
    ReportName: 'Visitors By Date Range',
    ReportSubText: 'This report shows visitors who arrived within the selected date range',
    ReportGroup: 'Visitors',
    ReportExecuteName: 'visitors_visitorsByDateRange',
    Filters: [
      {
        type: 'date',
        label: 'From Date',
        fieldName: 'startDate',
        required: true,
      },
      {
        type: 'date',
        label: 'To Date',
        fieldName: 'endDate',
        required: true,
      },
    ],
    Columns: [
      { title: 'Visitor', field: 'Visitor', width: 150, editor: 'input', headerFilter: true },
      { title: 'Company', field: 'Company', width: 150, editor: 'input', headerFilter: true },
      { title: 'Description', field: 'Description', width: 200, editor: 'input', headerFilter: true },
      { title: 'Main Host', field: 'MainHost', width: 150, editor: 'input', headerFilter: true },
      { title: 'Arrival Time', field: 'ArrivalTime', width: 180, editor: 'input', headerFilter: true },
      { title: 'Location', field: 'Location', width: 150, editor: 'input', headerFilter: true },
      { title: 'Visit User Type', field: 'VisitUserType', width: 150, editor: 'input', headerFilter: true },
      { title: 'Visit Category', field: 'VisitCategory', width: 150, editor: 'input', headerFilter: true },
    ],
  },
  {
    ReportName: 'Failed Checked-ins By Date Range',
    ReportSubText: 'This report shows failed visitor check-ins within the selected date range',
    ReportGroup: 'Visitors',
    ReportExecuteName: 'visitors_failedCheckInsByDateRange',
    Filters: [
      {
        type: 'date',
        label: 'From Date',
        fieldName: 'startDate',
        required: true,
      },
      {
        type: 'date',
        label: 'To Date',
        fieldName: 'endDate',
        required: true,
      },
    ],
    Columns: [
      { title: 'Visitor', field: 'Visitor', width: 150, editor: 'input', headerFilter: true },
      { title: 'Company', field: 'Company', width: 150, editor: 'input', headerFilter: true },
      { title: 'Description', field: 'Description', width: 200, editor: 'input', headerFilter: true },
      { title: 'Host', field: 'Host', width: 150, editor: 'input', headerFilter: true },
      { title: 'Failure Time', field: 'FailureTime', width: 180, editor: 'input', headerFilter: true },
      { title: 'Location', field: 'Location', width: 150, editor: 'input', headerFilter: true },
      { title: 'Visit User Type', field: 'VisitUserType', width: 150, editor: 'input', headerFilter: true },
      { title: 'Visit Category', field: 'VisitCategory', width: 150, editor: 'input', headerFilter: true },
    ],
  },
]
